import React from "react";
import Index from "../_components/SessionCategoryManagement/Index";

function SessionCategoryManagement() {
  return <Index />;
}

export default SessionCategoryManagement;
